import React, { useContext, useState } from 'react'
import { Link, navigate } from 'gatsby'
import { LanguageContext } from '../context'
import { homePagePaths, translate } from '../translate'
import Modal from "./modal"
import ToastMessage from "./toast"
import backgroundImage from "../assets/images/modal/modal-header-image.jpg"
import { useToasts } from "react-toast-notifications"

const ButtonVisitUs = (props) => {

  const { t } = useContext(LanguageContext)
  const { lang } = props

  const [show, setShow] = useState(false)
  const handleShow = () => setShow(true)

  const [modalShow, setModalShow] = useState(false);
  const [messageShow, setMessageShow] = useState(false);

  const modalFooter = () => {
    return(
      <>
        <p>{t("Si necessites ajuda, posa’t en contacte amb nosaltres mitjançant el número de telèfon (+34) 937 88 16 61, de dilluns a diumenge de 9:00 a 17:00, o envia’ns un correu electrònic a info@fundaciogoel.es.")}</p>
      </>
    )
  }

  const sendMessage = (response) => {
    setModalShow(false)
    setMessageShow(true);
  }

  const { addToast } = useToasts()

  const {title=t("Fes un donatiu"), className="btn btn-outline btn-outline-visit-us my-2 my-sm-0 bordeaux"} = props

  return (
   <>
     <div
     className="form-inline my-2 my-lg-0 visit-us">
     {/*<button
       className={className}
       type="submit"
       onClick={() => setModalShow(true)}
       >{title}</button> */}
       <Link
        to={`${lang === 'ca' ? '/donatius' : `/${lang}/donatius` }`}
        className={className}
        title={title}
       >
        {title}
       </Link>
     </div>

     <ToastMessage
      show={messageShow}
      title={t("Dades enviades")}
      message={t("Dades enviades correctament. Aviat es posarà en contacte amb tu una persona de la UNIDA. Gràcies!")}
      onClose={() => setMessageShow(false)}
      position="top-center"
      lang={props?.lang}
      />
     <Modal
       title={t("Planifica la teva Visita")}
       description={t("Si tens previst visitar-nos, tenim informació que t'ajudarà a aprofitar al màxim la teva estada! Omple el següent formulari i Explora totes les oportunitats que ofereix la nostra església durant tota la setmana. Et contactarem el més aviat possible!")}
       show={modalShow}
       onHide={() => setModalShow(false)}
       backgroundimage={backgroundImage}
       size='lg'
       className="modal-unida"
       theform='visit_us_goel_webform'
       footer={modalFooter()}
       sendMessage={(response) => sendMessage(response)}
       lang={props?.lang}
        id="modal-visit-us"

       />
   </>
 )
}

export default ButtonVisitUs
